import {
  API_ERROR,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  VENDORS,
  VENDORS_LIST_SUCCESSFUL,
  VENDORS_ADD,
  VENDORS_ADD_SUCCESSFUL,
  VENDORS_EDIT,
  VENDORS_EDIT_SUCCESSFUL,
  VENDORS_DELETE,
  VENDORS_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
  VENDOR_GST_VALIDATION,
  // GET_VENDOR_DETAILS,

  // VENDORS_ROW_SUCCESSFUL,
  UPLOAD_REQUEST,
  UPLOAD_PRODUCTVENDORS_REQUEST,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  vendorslist: [],
  model: false,
  error_msg: null,
  rowdata: {},
};

const department = (state = initialState, action) => {
  switch (action.type) {
    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case SELECT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case VENDORS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case VENDORS_LIST_SUCCESSFUL:
      state = {
        ...state,
        vendorslist: action.payload.response,
        loading: false,
      };
      break;
    case VENDORS_ADD:
      state = {
        ...state,
        loading: false,
        model: true,
      };
      break;
    case VENDORS_ADD_SUCCESSFUL:
      state = {
        ...state,
        // message: action.payload,
        loading: false,
        model: false,
        rowdata: { Id: 0 },
      };
      break;
    case VENDORS_EDIT:
      state = {
        ...state,
        model: true,
        rowdata: {
          ...action.payload,
          state_id: action.payload.state?.id,
          stateLabel: action.payload.state?.name,
        },
      };
      break;
    case VENDORS_EDIT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        model: false,
        rowdata: { Id: 0 },
      };
      break;
    case VENDORS_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case VENDORS_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case VENDOR_GST_VALIDATION:
      state = {
        ...state,
        loading: false,
      };
      break;

    // case VENDORS_ROW_SUCCESSFUL:
    //   state = {
    //     ...state,
    //     rowdata: action.payload.response.data,
    //     loading: false,
    //   };
    //   break;

    // case GET_VENDOR_DETAILS:
    //   state = {
    //     ...state,
    //     loading: true,
    //   };
    //   break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;
    case UPLOAD_REQUEST:
      state = {
        ...state,
        loading: false,
      };
      break;
    case UPLOAD_PRODUCTVENDORS_REQUEST:
      state = {
        ...state,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default department;
